module.exports = __webpack_public_path__ + "static/media/bg-arlet-diffuser-mobile.de4aeb5e.jpg";